<ng-container *ngIf="def != null && _options != null">
    <sm-toolbar>
        <p-button icon="fas fa-run" label="Import starten" (onClick)="import()"></p-button>
        <p-button icon="fas fa-save" label="Importkonfiguration in Datei speichern" (onClick)="saveConfig()"></p-button>
        <p-button icon="fas fa-open" label="Importkonfiguration aus Datei laden" (onClick)="loadConfig()"></p-button>
        <p-button icon="fas fa-times" label="Abbrechen" (onClick)="cancel()"></p-button>
    </sm-toolbar>
    <sm-form [form]="form">
    </sm-form>
    <p-panel *ngFor="let archive of _options.archives; index as index" [header]="'Schrank ' + archive.archive.name">
        <sm-form [form]="forms[index]">
        </sm-form>
        <sm-table2 class="height300p" [data]="tables[index]" [autoHeight]=true></sm-table2>
</p-panel>
</ng-container>
